import moment from "moment";

// Rush Hour is 8-12PM local time.
export default function isRushHour() {
	const currentHour = moment().hour();

	return currentHour >= 20 && currentHour < 24;
}



// WEBPACK FOOTER //
// ./src/shared/util/isRushHour.js